import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

export const useAddMedicalHistory = () => {
  const queryClient = useQueryClient();
  const patientId = useCurrentPatientId();
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async (newHistory) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/patientmedicalhistory`,
        {
          tenant: tenantVal,
          patientId,
          ...newHistory,
        }
      );
      return response.data;
    },
    onSuccess: () => {
      toast.success("Medical history added successfully!");
      queryClient.invalidateQueries({ queryKey: ["medicalHistory"] });
    },
  });
};
